import {Prompt, useHistory} from "react-router-dom";
import React, {useEffect} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretRight} from "@fortawesome/free-solid-svg-icons";
import {pathFor} from "../../../constants/apiPaths";
import Request from 'services/Request';

function PubmaticURLsBlacklistForm(props) {
    const {setMessageQueue} = props;
    const history = useHistory();
    const isEdit = history.location.pathname.includes('editURLsBlacklist');
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [name, setName] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [urls, setURLs] = React.useState('');
    const [active, setActive] = React.useState(false);
    const urlBlacklistId = isEdit ? history.location.pathname.split('/').pop() : null;

    const fetchURLsBlacklist = async () => {
        try {
            const {
                statusCode,
                jsonResponse
            } = await Request(pathFor.pubmaticURLsBlacklist + `?ids=${urlBlacklistId}`, {}, {}, "GET")
            if (statusCode === 200) {
                const {global_blacklist} = jsonResponse
                const {name, description, urls, active} = global_blacklist[0]
                setName(name)
                setDescription(description)
                setURLs(urls.join('\n'))
                setActive(active)
            } else if (statusCode === 401) {
                setMessageQueue([jsonResponse])
            } else {
                setMessageQueue([{"error": "Unable to fetch data."}])
            }
        } catch (err) {
            setMessageQueue([{"error": "Server error. Try again after sometime."}])
        }
    }
    const clearForm = () => {
        setName('');
        setDescription('');
        setURLs('');
        setActive(false);
    }
    useEffect(async () => {
        if (isEdit) {
            await fetchURLsBlacklist();
        }
    }, [])
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const payload = {
                name,
                description,
                urls: urls.split('\n').map(url => url.trim()),
                active
            }
            if (isEdit) {
                payload.id = history.location.pathname.split('/').pop();
            }
            const response = isEdit ? await Request(pathFor.editPubmaticURLsBlacklist, payload) : await Request(pathFor.createPubmaticURLsBlacklist, payload);
            // setIsSubmitting(false);
            if (response.statusCode === 200 || response.statusCode === 201) {
                clearForm();
                setMessageQueue([{
                    success: isEdit
                        ? "Blacklist updated successfully!"
                        : "Blacklist created successfully!"
                }]);
                // Redirect after short delay
                setTimeout(() => {
                    history.push(pathFor.pubmaticHome, {tabIndex: 3});
                }, 500);
            } else {
                const errorMessage = response.jsonResponse?.errors
                    ? Object.values(response.jsonResponse.errors)[0]
                    : "An error occurred while saving the segment.";
                setMessageQueue([{error: errorMessage}]);
            }
        } catch (error) {
            console.error(error);
            setIsSubmitting(false);
        }
    }
    return (
        <>
            <Prompt
                when={!isSubmitting}
                message="You have unsaved changes. Are you sure you want to leave?"
            />
            <div className="crumb bg--secondary w-100 py-2 px-3 rounded">
                <span className="mr-2">URLs blacklist</span>
                <FontAwesomeIcon icon={faCaretRight} className="caret-right"/>
                <strong className="ml-2">
                    {isEdit ? "Edit urls blacklist" : "Create urls blacklist"}
                </strong>
            </div>
            <div className="operation-table my-3 d-flex align-items-center">
                <p className="mb-0 me-3 push">
                    {isEdit ? "Edit urls blacklist" : "Create urls blacklist"}
                </p>
            </div>
            <div className='d-flex size-responsive'>
                <form onSubmit={handleSubmit} className='p-0 pt-responsive flex-grow-1 mr-4'>
                    <div className="mb-3">
                        <input type="text" className="form-control border py-2 px-3 w-100 rounded" id="name"
                               value={name} onChange={(e) => setName(e.target.value)}
                               placeholder="Enter name" required/>
                    </div>
                    <div className="mb-3">
                        <textarea className="form-control border py-2 px-3 w-100 rounded" id="description"
                                  value={description} onChange={(e) => setDescription(e.target.value)}
                                  placeholder="Enter description" rows="3"/>
                    </div>
                    <div className="mb-3">
                        <textarea className="form-control border py-2 px-3 w-100 rounded" id="domains"
                                  value={urls} onChange={(e) => setURLs(e.target.value)}
                                  placeholder="Enter URLs"
                                  rows="5"/>
                    </div>
                    <div className="mb-3">
                        <div className="restrict">
                            <input
                                type="checkbox"
                                id="active"
                                checked={active || false}
                                onChange={(e) => setActive(e.target.checked)}
                            />
                            <label className="form-check-label ml-2" htmlFor="active">
                                Active
                            </label>
                        </div>
                    </div>
                    <button type="submit" className="btn bg--primary text--white px-3">
                        {isEdit ? "Update" : "Create"}
                    </button>
                </form>
            </div>
        </>
    )
}

export default PubmaticURLsBlacklistForm
